/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diaglab-bill-payment.reducer';

export const DiaglabBillPaymentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diaglabBillPaymentEntity = useAppSelector(state => state.diaglabBillPayment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diaglabBillPaymentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.detail.title">DiaglabBillPayment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.id">Id</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.id}</dd>
          <dt>
            <span id="paymentMethod">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.paymentMethod">Payment Method</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.paymentMethod}</dd>
          <dt>
            <span id="transactionDetails">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.transactionDetails">Transaction Details</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.transactionDetails}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.paidAmount}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.modifiedByID}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.active">Active</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.timestampentry}</dd>
          <dt>
            <span id="settledAtHospital">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.settledAtHospital">Settled At Hospital</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.settledAtHospital ? 'true' : 'false'}</dd>
          <dt>
            <span id="paymentStatus">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.paymentStatus">Payment Status</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.paymentStatus}</dd>
          <dt>
            <span id="voided">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.voided">Voided</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.voided ? 'true' : 'false'}</dd>
          <dt>
            <span id="voidedReason">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.voidedReason">Voided Reason</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.voidedReason}</dd>
          <dt>
            <span id="voidedDate">
              <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.voidedDate">Voided Date</Translate>
            </span>
          </dt>
          <dd>{diaglabBillPaymentEntity.voidedDate}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.diaglabBill">Diaglab Bill</Translate>
          </dt>
          <dd>{diaglabBillPaymentEntity.diaglabBill ? diaglabBillPaymentEntity.diaglabBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.hospitalPayment">Hospital Payment</Translate>
          </dt>
          <dd>{diaglabBillPaymentEntity.hospitalPayment ? diaglabBillPaymentEntity.hospitalPayment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.subscriber">Subscriber</Translate>
          </dt>
          <dd>{diaglabBillPaymentEntity.subscriber ? diaglabBillPaymentEntity.subscriber.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabBillPayment.claim">Claim</Translate>
          </dt>
          <dd>{diaglabBillPaymentEntity.claim ? diaglabBillPaymentEntity.claim.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diaglab-bill-payment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diaglab-bill-payment/${diaglabBillPaymentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiaglabBillPaymentDetail;
